import { names, requestSuccessFailure } from 'utilities/constants';

export const PREFIX = 'MANUAL_LOOKUP';

export default {
    ...names('SHOW_MANUAL_LOOKUP_DIALOG',
        'HIDE_MANUAL_LOOKUP_DIALOG',
        'MANUAL_LOOKUP_MULTIPLE_RESULTS',
        'SHOW_MULTIPLE_MATCHES_DIALOG',
        'HIDE_MULTIPLE_MATCHES_DIALOG'),
    ...requestSuccessFailure(PREFIX)
} 